import { Box, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { ReactNode } from 'react';
import { Button } from '../Button';

interface Props {
  children: ReactNode;
  onClose?: () => void;
  onDelete?: () => void;
  deleteButtonTitle?: string;
  small?: boolean;
}

export const ModalTitle: React.FC<Props> = ({ children, onClose, onDelete, deleteButtonTitle, small = false }) => {
  return (
    <DialogTitle
      sx={{
        fontFamily: 'Instrument Sans',
        fontSize: '1.375rem',
        lineHeigth: '1.75rem',
        fontWeight: 500,
        color: '#1D1B20',
        padding: small ? '1.5rem 1.5rem 1rem 1.5rem' : '1.5rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      {children}
      {onDelete && (
        <Button sx={{ width: '15.625rem' }} type="outline" onClick={onDelete}>
          {deleteButtonTitle}
        </Button>
      )}
      {onClose && (
        <IconButton
          sx={{
            '&:hover': {
              borderRadius: 0,
            },
            '&:active': {
              borderRadius: 0,
            },
          }}
          size="small"
          onClick={onClose}
        >
          <CloseIcon sx={{ color: '#45464F', height: '1.5rem', width: '1.5rem' }} />
        </IconButton>
      )}
    </DialogTitle>
  );
};
